import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lands here from auth.emergentagent.com as /account#session_id=… .
// Exchanges the one-time session_id server-side, then drops into HQ.
export default function GoogleAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/account/login", { replace: true }); return; }
    axios.post(`${API}/customer/auth/google/session`, { session_id: sessionId }, { withCredentials: true })
      .then((r) => {
        if (r.data?.token) localStorage.setItem("heritage-customer-token", r.data.token);
        if (r.data?.email) localStorage.setItem("heritage-customer-email", r.data.email);
        if (r.data?.name) localStorage.setItem("heritage-customer-name", r.data.name);
        window.dispatchEvent(new Event("heritage-customer-session"));
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true, state: { user: r.data } });
      })
      .catch((e) => setError(e?.response?.data?.detail || "Google sign-in didn't complete. Please try again."));
  }, [location.hash, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBF6E9] p-6" data-testid="google-callback-error">
        <div className="max-w-sm text-center space-y-3">
          <p className="text-[#A33030]">{error}</p>
          <button type="button" onClick={() => navigate("/account/login", { replace: true })} className="underline text-[#6E1E3A]">Back to sign in</button>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF6E9]" data-testid="google-callback">
      <Loader2 className="w-6 h-6 animate-spin text-[#6E1E3A]" />
    </div>
  );
}
